export {LanguageSelectorComponent} from './language-selector'
export {languages} from './languages.model'
export {I18nPipe} from './i18n.pipe'
export {I18nService} from './i18n.service'



// WEBPACK FOOTER //
// ./src/app/shared/i18n/index.ts